export const training = {
    route: '智能训练',
    selectDevice: '选择设备',
    saveEvent: '保存事件',
    changeEvent: '修改事件',
    addNew: '添加新...',
    saveSelected: '保存已选事件',
    l1unknown: 'L1 未知',
    l2unknown: 'L2 未知',
    l3unknown: 'L3 未知',
    l123unknown: '3相未知',
    l1devices: 'L1 设备',
    l2devices: 'L2 设备',
    l3devices: 'L3 设备',
    l123devices: '3 相设备',
    unknownDevice: '未知设备',
    deleted: '已删除',
    filterDevice: '过滤:',
    unknownDevices: '未知设备',
    none: '无',
    zoomSelection: '缩放选择',
    clearSelection: '清除选择',
    clearZoom: '取消缩放',
    groupBy: '分组',
    groupByPhases: '相',
    groupByDevices: '设备',
    groupBy5Clusters: '5 聚类',
    groupBy10Clusters: '10 聚类',
    groupBy20Clusters: '20 聚类',
    unknown: '未知',
    others: '其它设备',
    cluster: '聚类',
    smartTipsTitle: '如何使用智能训练?',
    smartTips: [
        { key: 0 , text: '这里可以看到过去30天内监控范围内发生的所有事件。需要查看特定时间阶段,可以移动图像顶端的滑块.'},
        { key: 1 , text: '默认情况,按相将事件分组,也可以选择按设备进行分组的其它选项，或者从位于顶端右部的选择盒按不同聚类尺寸进行分组.'},
        { key: 2 , text: '可以使用鼠标滚轮或触摸板进行缩放，也可拖动图形进行平移。若要恢复原始尺寸，请使用右上角的按钮，取消缩放或选择.'},
        { key: 3 , text: '两种事件类型：小圆圈代表已分配设备；大圆圈代表未知设备.'},
        { key: 4 , text: '要将未知事件分配给设备，请单击并选择它们，然后按"保存所选事件"按钮。那里可以为所选事件创建新设备，也可以将其分配给现有设备。'}
    ],
    selectPeriod: '选择周期',
    last2min: '过去 2 分钟',
    last5min: '过去 5 分钟',
    last10min: '过去 10 分钟',
    last30min: '过去 30 分钟',
    last1hour: '去过 1 小时',
    last3hours: '过去 3 小时',
    last6hours: '过去 6 小时',
    last12hours: '过去 12 小时',
    last24hours: '过去 24 小时',
    today: '今天',
    yesterday: '昨天',
    thisWeek: '本周',
    lastWeek: '上周',
    thisMonth: '本月',
    lastMonth: '上月',
    thisQuarter: '本季度',
    lastQuarter: '上個季度',
    thisYear: '今年',
    lastYear: '去年',
    otherPeriod: '其他最多1年',
    durationError: '超过1年',
    from: '从',
    to: '至',
    powerUsageLabel: '电力消耗  瓦特/无功',
    recognitionTblNameCol: '名称',
    recognitionTblCountCol: '数量',
    recognitionTblWattCol: '活瓦數消耗',
    recognitionTblWattHoursCol: '瓦特小时数',
    recognitionTblPercentCol: '百分比',
    recognitionTblSelectedCol: '已选',
    alwaysOnTblDayCol: '天',
    alwaysOnTblP1Col: '相 1',
    alwaysOnTblP2Col: '相 2',
    alwaysOnTblP3Col: '相 3',
    totalKwh: '消耗千瓦時',
    recognitionKwh: '识别 千瓦时',
    classificationKwh: '分类 千瓦时',
    alwaysOnKwh: '一直运行 千瓦时',
    completeness24h: '原始数据完整性 (过去 24 小时)',
    completeness1h: '原始数据完整性 (过去 60 分钟)',
    recognitionRate: '识别率',
    recognitionCorrectness: '识别准确度',
    classificationRate: '分类率',
    recognitions: '识别',
    recognitionsMobile: '實時電源使用',
    alwaysOnPerDay: '每天一直运行',
    singleGraphYLabel: '电力消耗 / 温度',
    singleGraphUsage: '电力消耗',
    singleGraphTemp: '温度',
    singleGraphStatus: '状态',
    addonGraphYLabel: '高级数据',
    kwhCost: '每千瓦时价格',
    wattUnit: '瓦',
    wUnit: '瓦',
    kwUnit: '千瓦',
    mwUnit: '兆瓦',
    kwhUnit: '千瓦时',
    kgUnit: '公斤',
    costUnit: '元',
    var: '伏特安培无功',
    periodPicker: '期間（最多 7 天)',
    deviceAssistant: '设备助手',
    meterShortName: '仪表短名称（可选',
};
